exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".asset-preview[data-v-6aee94ae]{border:2px solid #e4e4e4;border-radius:.35rem}.asset-preview.in-selection[data-v-6aee94ae]{border-color:#ced4da}.asset-preview .thumbnail[data-v-6aee94ae]{padding:0;height:198px}.asset-preview .thumbnail img[data-v-6aee94ae]{max-width:100%}.asset-preview.in-selection .thumbnail[data-v-6aee94ae]{height:128px}.asset-preview.in-selection .thumbnail img[data-v-6aee94ae]{max-height:128px}.asset-preview:hover .card-body .asset-info.stay[data-v-6aee94ae]{opacity:1}.preview-loading[data-v-6aee94ae]{position:absolute;left:0;top:0;right:0;bottom:0;margin:auto;z-index:2;height:20px}", ""]);

// exports
